import { Flex, Text } from "@/atoms"
import * as AdrDomain from "@/domain/adr"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { InformationAlert } from "@/molecules/InformationAlert"
import { TipList } from "@/pages/TriagePage/components/molecules/TipList"
import {
  getEnforcementValues,
  getTranslations,
  getValues,
  translationsWithVM
} from "@/pages/TriagePage/components/pages/AdrPage/helpers"
import { AdrTabTemplate } from "@/pages/TriagePage/components/templates/AdrTabTemplate"
import { Description } from "../Description"
import { TableDetailsAdr } from "./components/TableDetailsAdr"
import { getWhatItems, getWhereItems } from "./helpers"

import styles from "./DetailsTabAdr.module.scss"

import type { AdrIncident } from "@/domain/adr"

export const DetailsTabAdr = (props: { incident: AdrIncident }) => {
  const { incident } = props
  const { type, what } = incident
  const keyPrefix = `triage.adr.incidents.${type}.details`
  const { t } = useTranslation("translation", { keyPrefix })
  const { t: tTab } = useTranslation("translation", {
    keyPrefix: "triage.adr.tabs.details"
  })
  const { t: tAll } = useTranslation()

  const values = getValues({
    ...what,
    ...getEnforcementValues(incident),
    ...getTranslations(incident, tAll)
  })
  const attr = { values, t }
  const tip1 = translationsWithVM("tips.1", incident, attr)
  const tip3 = translationsWithVM("tips.3", incident, attr)
  const tip4 = translationsWithVM("tips.4", incident, attr)
  const tip5 = translationsWithVM("tips.5", incident, attr)
  const tip6 = translationsWithVM("tips.6", incident, attr)
  const vmTip1 = AdrDomain.isVM(incident) ? t("tips.VM_1", values) : null

  const summary2 = t("summary2", { defaultValue: "", ...values })
  const description1 = t("tips.1_description", "")

  return (
    <AdrTabTemplate>
      <Description title={tTab("summary")}>
        <Text>
          <Trans>{translationsWithVM("summary", incident, attr)}</Trans>
        </Text>
        {summary2 && (
          <Text>
            <Trans>{summary2}</Trans>
          </Text>
        )}
      </Description>
      <Flex vertical gap={40}>
        <Description title={tTab("what")} gap={16}>
          <TableDetailsAdr dataSource={getWhatItems(incident, tAll)} />
        </Description>
        <Description title={tTab("where")} gap={16}>
          <TableDetailsAdr dataSource={getWhereItems(incident)} />
        </Description>
      </Flex>
      <Description title={tTab("tips")} gap={12}>
        <Flex vertical gap={10}>
          <InformationAlert
            message={translationsWithVM("tips.info", incident, attr)}
            className={styles.infoAlert}
          />
          <TipList>
            {!description1 && tip1}
            {!!description1 && (
              <Flex vertical>
                <span>{tip1}</span>
                <span className={styles.tipsListDescription}>
                  {description1}
                </span>
              </Flex>
            )}
            {translationsWithVM("tips.2", incident, attr)}
            {tip3 && tip3}
            {tip4 && tip4}
            {tip5 && tip5}
            {tip6 && tip6}
            {vmTip1 && vmTip1}
          </TipList>
        </Flex>
      </Description>
    </AdrTabTemplate>
  )
}
